export const PHONE_NUMBER = /^\(\d{2}\) \d{5}-\d{4}$/;

export const UPPERCASE_LETTER = /[A-Z]/;

export const LOWERCASE_LETTER = /[a-z]/;

export const SPECIAL_CHARACTER = /[^A-Za-z0-9]/;
